import 'ag-grid-enterprise'
import { useGetAllPersons } from '@hr/api/endpoints'
import { AgCharts } from 'ag-charts-react'
import { useTranslation } from 'react-i18next'
import { customChartThemes } from '../../common/grid'
import { LoadingContainer } from '../../common/loaders/loadingcontainer'
import { localized } from '../../common/utils'
import styles from '../../statisticsview/salaryhistory/cards/Card.module.css'

export function ChartGender() {
	const { t } = useTranslation()
	const { data: persons } = useGetAllPersons()

	const countGenders = () => {
		let male = 0
		let female = 0
		persons.forEach((person) => {
			const status = person.employmentDetails?.personStatus
			if ((status === 'EMPLOYED' || !status) && person.socSec) {
				const g = (person.gender || '').trim().toUpperCase()
				if (g === 'M') ++male
				else if (g === 'N') ++female
			}
		})

		const total = male + female
		if (total === 0) return

		return [
			{
				category: `${t('Women', 'Naiset')} ${female}`,
				amount: female,
				share: female / total,
				callout: `${t('Women', 'Naiset')} ${localized.numberFormatFraction1.format((female / total) * 100)} %`,
			},
			{
				category: `${t('Men', 'Miehet')} ${male}`,
				amount: male,
				share: male / total,
				callout: `${t('Men', 'Miehet')} ${localized.numberFormatFraction1.format((male / total) * 100)} %`,
			},
		]
	}

	const data = persons ? countGenders() : []

	/** @type {import("ag-grid-enterprise").AgChartOptions} */
	const options = {
		data,
		series: [
			{
				type: 'donut',
				outerRadiusRatio: 0.8,
				//innerRadiusOffset: -30,
				angleKey: 'share',
				calloutLabelKey: 'callout',
				legendItemKey: 'category',
				fills: ['#8F6EFA', '#DACFFF'],
				tooltip: {
					renderer: ({ datum }) => ({
						title: datum.callout,
						data: [],
					}),
				},
			},
		],
		theme: customChartThemes.chartTheme,
		locale: localized.agChartsLocale,
	}

	return data?.length > 0 ? (
		<>
			<h4 className={styles.cardHeader}>{t('GenderDistribution', 'Sukupuolijakauma')} %</h4>
			<AgCharts options={options} />
		</>
	) : (
		<LoadingContainer />
	)
}
